import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoading: false,
  isAuthenticated: false,
  currentUser: {},
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.currentUser = action.payload;
    },
    loginFail: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.currentUser = {};
      state.error = action.payload;
    },
    logOutUser: (state, action) => {
      state.isAuthenticated = false;
      state.currentUser = {};
    },
  },
});

export const { loginStart, loginSuccess, loginFail, logOutUser } =
  authSlice.actions;

const authReducer = authSlice.reducer;
const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["currentUser", "isAuthenticated"],
};

export default persistReducer(persistConfig, authReducer);
